import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Chevron icon (points down by default).
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 * Rotate via CSS (e.g. `transform: rotate(180deg)`) or pass `style` for up/left/right variants.
 */
const ChevronIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M5.64639 9.0206C5.45117 8.82537 5.45124 8.50884 5.64639 8.31356C5.84165 8.1183 6.15816 8.1183 6.35342 8.31356L9.88174 11.8419C9.94683 11.907 10.053 11.907 10.1181 11.8419L13.6464 8.31356C13.8417 8.1183 14.1582 8.1183 14.3534 8.31356C14.5486 8.50884 14.5486 8.82537 14.3534 9.0206L10.8251 12.5489C10.3695 13.0045 9.63032 13.0045 9.17471 12.5489L5.64639 9.0206Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronIcon;
